import { Stethoscope } from "lucide-react";
import { BereichSeite } from "@/components/crm/Bereich";
import CRMDashboard from "@/components/crm/CRMDashboard";
import CRMAppointments from "@/components/crm/CRMAppointments";
import CRMCustomers from "@/components/crm/CRMCustomers";
import CRMAnfragen from "@/components/crm/CRMAnfragen";

export default function CRMBeratung() {
  return (
    <BereichSeite titel="Pflegeberatung" untertitel="Beratungsanfragen, Beratungskunden, Termine und Beratungsbögen (§ 37.3 SGB XI)" icon={Stethoscope} tabs={[
      { key: "uebersicht", label: "Übersicht", render: () => <CRMDashboard /> },
      { key: "termine", label: "Termine", render: () => <CRMAppointments /> },
      { key: "kunden", label: "Beratungskunden", render: () => <CRMCustomers /> },
      { key: "anfragen", label: "Anfragen", render: () => <CRMAnfragen bereich="pflegeberatung" /> },
    ]} />
  );
}
